let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dJT4h")).then(() => parcelRequire('e6FFe'));